import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, timeout: 20000 });

export const fetchSettings = async () => {
  const { data } = await client.get("/settings");
  return data;
};

export const fetchServices = async () => {
  const { data } = await client.get("/services");
  return data;
};

export const fetchAvailability = async () => {
  const { data } = await client.get("/availability");
  return data;
};

export const fetchSlots = async (date, serviceIds) => {
  const { data } = await client.get("/availability/slots", {
    params: { date, services: serviceIds.join(",") },
  });
  return data;
};

export const createBooking = async (payload) => {
  const { data } = await client.post("/bookings", payload);
  return data;
};

export const fetchBookingByCode = async (code) => {
  const { data } = await client.get(`/bookings/${code}`);
  return data;
};

// URL for the .ics calendar download — used by the "Add to calendar" button
// on the success screen so customers can drop the booking into Google,
// Outlook, or Apple Calendar in one tap.
export const bookingIcsUrl = (code) => `${API}/bookings/${code}/ics`;
